import React, { useEffect , useContext} from "react";
import "./Home.css";
import Navbar from "../../components/Navbar/Navbar.jsx";
import { useNavigate, useLocation } from "react-router-dom";
import homeLogo from "../../assets/images/homeLogo.svg";
import welcomeBot from "../../assets/images/welcomeBot.png"
import introIcon from "../../assets/images/introIcon.svg"
import errorIcon from "../../assets/images/errorIcon.svg"
import rowDeletedIcon from "../../assets/images/rowDeletedIcon.svg"
import tickCircleIcon from "../../assets/images/tickCircleIcon.svg"
import introIconDark from "../../assets/images/introIconDark.svg"
import errorIconDark from "../../assets/images/errorIconDark.svg"
import rowDeletedIconDark from "../../assets/images/rowDeletedIconDark.svg"
import tickCircleIconDark from "../../assets/images/tickCircleIconDark.svg"
import { ThemeContext } from "../../contexts/ThemeContext.js";

import { useTranslationContext } from "../../contexts/TranslationContext";
import { ToastContainer, toast } from "react-toastify";
import { useEventEmitter } from "../../contexts/EventEmmiter.js";

const Home = () => {
  const navigate = useNavigate();
  const { translations } = useTranslationContext();
  const location = useLocation();
  const { isDarkMode } = useContext(ThemeContext); // Use the ThemeContext


  // Translation variables
  const disclaimer1 = translations["disclaimer_1"] || "ChatNPP, powered by AI, provides insights on the NPP Portfolio using UPL's proprietary data.";
  const disclaimer2 = translations["disclaimer_2"] || "Your data is deleted after the session and is not stored";
  const disclaimer3 = translations["disclaimer_3"] || "Responses may contain errors - always verify the information.";
  const disclaimer4 = translations["disclaimer_4"] || "For the best answers, ask clear, specific questions with context or examples.";
  const title1 = translations["title1"] || "Discover a seamless way to explore NPP products with ChatNPP—your intelligent virtual agent powered by Generative AI, designed to provide human-like conversations.";
  const welcome = translations["welcome_to"] || "Welcome to";
  const howItWorks = translations["how_it_works"] || "How it works?";
  const chatButtonText = translations["chat_button"] || "Get Started";


  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message);
      navigate(".", { replace: true, state: {} });
    }
  }, [location.state, navigate]);

  const handleChatButtonClick = () => {
    navigate("/chat");
  };

  const { emit } = useEventEmitter();
  useEffect(() => {
    emit('resetChild', 'chatHistory');
    // eslint-disable-next-line
  }, [])


  return (
    <div className={`home-container ${isDarkMode ? 'dark-mode' : 'light-mode'}`}> 
      <ToastContainer closeButton={true} position="top-right" />
      <Navbar />
      <div className="container">
        <div className="main-content">
          <div className={`welcome-section  ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
            <div className="mascot-wrapper">
              <img src={welcomeBot} alt="ChatNPP Mascot" className="mascot" />
            </div>

            <div className="centered-text-container">
              <span className={`welcome-home ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>{welcome}</span>
              <img src={homeLogo} alt="chatnpp-logo" className="home-npp-logo" />
              <div className={`info-text ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                {title1}
              </div>
              <div className={`description-text ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>{howItWorks}</div>
              <div className="how-it-works-steps">
                <div className="step">
                  <img src={isDarkMode? introIconDark : introIcon} alt="AI Icon" className="step-icon" />
                  <p className={`step-text ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                  {disclaimer1}
                  </p>
                </div>

                <div className="step">
                  <img src={isDarkMode? rowDeletedIconDark : rowDeletedIcon} alt="Lock Icon" className="step-icon" />
                  <p className={`step-text ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                   {disclaimer2}
                  </p>
                </div>

                <div className="step">
                  <img src={isDarkMode? errorIconDark : errorIcon} alt="Info Icon" className="step-icon" />
                  <p className={`step-text ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                   {disclaimer3}
                  </p>
                </div>

                <div className="step">
                  <img src={isDarkMode? tickCircleIconDark: tickCircleIcon} alt="Check Icon" className="step-icon" />
                  <p className={`step-text ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                   {disclaimer4}
                  </p>
                </div>
              </div>

              <button className="get-started-btn" onClick={handleChatButtonClick}>{chatButtonText}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};
export default Home;